import Firebase, { Functions } from '../EnoticeFirebase';

export const getCreateCustomerFn = () =>
  getCallableFn(Functions.createCustomer);

export const getCreatePublisherDocsOnCallFn = () =>
  getCallableFn(Functions.createPublisherDocsOnCall);

export const getCloudConvertOnCallFn = () =>
  getCallableFn(Functions.cloudConvertOnCall);

const getCallableFn = (opts: { name: string; timeout: number }) =>
  Firebase.functions().httpsCallable(opts.name, {
    timeout: opts.timeout * 1000
  });
